import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Uf } from 'src/app/types/uf';
import { UF_LABELS } from 'src/app/types/uf_labels';

@Component({
  selector: 'app-uf-select',
  templateUrl: './uf-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UfSelectComponent),
      multi: true
    }
  ]
})
export class UfSelectComponent implements ControlValueAccessor {

  ufs = Object.values(Uf);
  labels = UF_LABELS;

  value: Uf | null = null;

  onChange = (value: Uf | null) => { };
  onTouched = () => { };

  writeValue(value: Uf | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setValue(value: Uf) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

}
